document.addEventListener('DOMContentLoaded', function () {


  // Prevent the Dynamic button from opening a new tab ==============================================
  document.querySelectorAll('.button.dynamic-link').forEach(function (link) {
    // Block middle-click (opens new tab)
    link.addEventListener('auxclick', function (e) {
      e.preventDefault();
    });

    // Block right-click context menu
    link.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });

    // Block Ctrl+click / Cmd+click (opens new tab)
    link.addEventListener('click', function (e) {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        return;
      }
      var embed = link.getAttribute('data-embed');
      if (embed) {
        sessionStorage.setItem('consultationEmbed', embed);
      }
    });
  });
  // END Prevent the Dynamic button from opening a new tab ===========================================


  // Consultation embed swap (sessionStorage bridge) =================================================
  var embed = sessionStorage.getItem('consultationEmbed');
  if (embed) {
    sessionStorage.removeItem('consultationEmbed');
    var embedEl = document.querySelector('[data-consultation-embed]');
    var defaultEl = document.querySelector('[data-consultation-default]');
    if (embedEl && defaultEl) {
      embedEl.innerHTML = embed;
      embedEl.querySelectorAll('script').forEach(function (oldScript) {
        var newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach(function (attr) {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
      embedEl.style.display = '';
      defaultEl.style.display = 'none';
    }
  }
  // END Consultation embed swap ====================================================================


});
